import "../GeneratingCourse/GeneratingCourse.scss";
import AiBot from "../../assets/images/vactor/chat-bot-icon.svg";

const GeneratingCourse = () => {
  return (
    <>
      <div className="generating-course-wrapper">
        <div className="generating-course-loading">
          <div className="square bounce2">
            <img src={AiBot} alt="" />
          </div>
          <div className="generating-course-steps">
            <div className="loading loading03">
              <span>G</span>
              <span>e</span>
              <span>n</span>
              <span>e</span>
              <span>r</span>
              <span>a</span>
              <span>t</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
            </div>
          </div>
      <div className="wait-msg">
        <div className="msg msg-1">
          Just a moment! This should only take a few minutes to complete.
        </div>
        <div className="msg msg-2">
          We're getting closer... just need another moment.
        </div>
        <div className="msg msg-3">
          We’re just putting the final touches in place. Almost ready!
        </div>
      </div>
        </div>
      </div>
    </>
  );
};

export default GeneratingCourse;
